import { render } from "./PlayerEditMenu.vue?vue&type=template&id=5eb860c7&scoped=true"
import script from "./PlayerEditMenu.vue?vue&type=script&lang=js"
export * from "./PlayerEditMenu.vue?vue&type=script&lang=js"

import "./PlayerEditMenu.vue?vue&type=style&index=0&id=5eb860c7&lang=scss&scoped=true"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb860c7"]])

export default __exports__